import apiClient from "./api";
const HORARIOSATENCION_API_BASE_URL = "/horariosAtencion";
class HorariosAtencionService {
  getHorariosAtencion() {
    return apiClient.get(HORARIOSATENCION_API_BASE_URL);
  }
  agregarHorariosAtencion(horarioAtencion) {
    return apiClient.post(HORARIOSATENCION_API_BASE_URL, horarioAtencion);
  }
  updateHorariosAtencion(horarioAtencion, horarioAtencionId) {
    return apiClient.put(HORARIOSATENCION_API_BASE_URL + "/" + horarioAtencionId, horarioAtencion);
  }
  deleteHorariosAtencion(horarioAtencionId) {
    return apiClient.delete(HORARIOSATENCION_API_BASE_URL + "/" + horarioAtencionId);
  }
  async getHorariosAtencionPorSucursal(sucursalId) {
    try {
      const response = await apiClient.get(`${HORARIOSATENCION_API_BASE_URL}/sucursal/${sucursalId}`,);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new HorariosAtencionService();